<template>
  <v-layout>
    <v-flex xs12 sm12 md12 lg12>
      <NameInput
        v-if="node.meta.type === 'title' || isTitle"
        :node="node"
        :editMode="editMode"
        :selectedRecord="selectedRecord"
        :isRoot="isRoot"
        :createMode="false"
      />
      <NonPeriodic
        v-else-if="node.meta.periodic === false"
        :node="node"
        :editMode="editMode"
        :selectedRecord="selectedRecord"
        :isRoot="isRoot"
        :createMode="false"
        v-on:resetform="resetForm()"
      />
      <Periodic
        v-else
        :node="node"
        :editMode="editMode"
        :showDateMode="showDateMode"
        :selectedRecord="selectedRecord"
        :isRoot="isRoot"
        :createMode="false"
        v-on:resetform="resetForm()"
      />
    </v-flex>
  </v-layout>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { parseConditionalStatement } from "../../utils/conditionalParser";
import Periodic from "./form-types/Periodic.vue";
import NonPeriodic from "./non-periodic-form-types/non-periodic.vue";
import NameInput from "./form-types/NameInput.vue";

export default {
  name: "FormFactory",
  props: {
    node: Object,
    editMode: Boolean,
    showDateMode: Boolean,
    selectedRecord: Object,
    singleEditModeid: String,
    isRoot: Boolean
  },
  components: {
    Periodic,
    NameInput,
    NonPeriodic
  },

  mounted() {
    this.showConditionalNodes();
    this.hideConditionalNodes();
    this.$root.$on("updatecondnodes", () => {
      if (this.node.meta["condition-type"]) {
        this.updateConditionals();
      }
    });
  },
  updated() {
    this.showConditionalNodes();
    this.hideConditionalNodes();
  },
  computed: {
    ...mapState({
      currentTabFullRecordId: state =>
        state.records.currentlySelectedTab.recordId
    }),
    isTitle() {
      return (
        this.node.meta.type === "text" && typeof this.node.value === "undefined"
      );
    }
  },
  data() {
    return {};
  },

  methods: {
    ...mapActions([
      "getRecordItemOnDemand",
      "addConditionallyHiddenRecordItemId",
      "removeAllConditionalHiddenRecordItemId"
    ]),
    hideConditionalNodes() {
      if (this.node.meta["condition-type"] && this.node.meta.condition) {
        let deciderNode = {};
        let deciderNodeMostRecentValue;
        let showNode = true;
        this.getRecordItemOnDemand({
          recorditemid: this.node.meta["condition-node"],
          recordid: this.currentTabFullRecordId
        }).then(async res => {
          deciderNode = res;

          if (res?.value.length) {
            deciderNodeMostRecentValue =
              res.value[deciderNode.value.length - 1].val;
          } else {
            deciderNodeMostRecentValue = undefined;
          }

          showNode = await parseConditionalStatement(
            this.node.meta.condition,
            this.node.value,
            deciderNodeMostRecentValue,
            // send entire node
            res,
            this.node.meta.evaltype
          );

          if (!showNode) {
            this.addConditionallyHiddenRecordItemId(this.node._id);
          }
        });
      }
    },

    showConditionalNodes() {
      this.removeAllConditionalHiddenRecordItemId();
    },

    resetForm() {
      this.$emit("resetform");
    },
    updateConditionals() {
      this.showConditionalNodes();
      this.hideConditionalNodes();
    }
  }
};
</script>

<style>
.layout {
  margin: 0;
}
</style>
